import { UserFacingError } from './errors'

export class WaiverNotMigratedError extends UserFacingError {
  constructor() {
    super("This waiver hasn't been set up for signing yet. Please contact the organization.")
    this.name = 'WaiverNotMigratedError'
  }
}

export class EsignProviderUnavailableError extends UserFacingError {
  constructor(
    message = 'The signing provider is temporarily unavailable. Please try again in a moment.',
  ) {
    super(message)
    this.name = 'EsignProviderUnavailableError'
  }
}
